
<mat-card class="card" [class.fullWidth]="fullWidth" [class.fullHeight]="fullHeight" [ngStyle]="{height: fullWidth && fullHeight ? 'calc(100% - 32px)' : ''}">
  <mat-card-header>
    <mat-card-title>

      <!-- Can go back -->
      <button *ngIf="canGoBack" mat-flat-button class="goback" (click)="goBack()"><mat-icon>arrow_back</mat-icon></button>

      <!-- Card title -->
      <span class="title" [innerHTML]="title"></span>

      <!-- Card actions -->
      <div class="actions" *ngIf="_cardActions">
        <button *ngFor="let action of _cardActions" mat-stroked-button color="primary" (click)="action.callback()" [disabled]="action.disabled">
          <mat-icon>{{action.icon}}</mat-icon>
          {{action.name | translate}}
        </button>
      </div>

    </mat-card-title>

    <!-- Divisor -->
    <div [class.divisor]="!hideDivisor" [ngStyle]="{ marginRight: fullWidth ? '0px' : '' }"></div>

  </mat-card-header>
  <mat-card-content>
    <div [class.container]="!fullWidth">
      <ng-content></ng-content>
    </div>
  </mat-card-content>
</mat-card>
